import { render, staticRenderFns } from "./WidgetEditorContentAreaComponentControls.vue?vue&type=template&id=22c80f14&"
import script from "./WidgetEditorContentAreaComponentControls.vue?vue&type=script&lang=js&"
export * from "./WidgetEditorContentAreaComponentControls.vue?vue&type=script&lang=js&"
import style0 from "./WidgetEditorContentAreaComponentControls.vue?vue&type=style&index=0&id=22c80f14&prod&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports